<template>
    <footer class="footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 text-center">
                    {{$t('string.msg.footer.text')}}
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
</style>